import { IApiGetAppointments } from 'features/appointment/services/types/api';
import moment from 'moment';

export const renderTime = (
  dataAppointment: IApiGetAppointments | undefined
) => {
  if (!dataAppointment) return;
  const isSameDate = moment(dataAppointment?.startTime).isSame(
    dataAppointment?.endTime
  );
  return isSameDate
    ? moment(dataAppointment?.startTime, 'MM/DD/YYYY').format('MM/DD/YYYY')
    : `${moment(dataAppointment?.startTime, 'MM/DD/YYYY').format(
        'MM/DD/YYYY'
      )} - ${moment(dataAppointment?.endTime, 'MM/DD/YYYY').format(
        'MM/DD/YYYY'
      )}`;
};

export function formatPhoneNumber(phoneNumber?: string) {
  if (!phoneNumber) return '';
  const digitsOnly = phoneNumber.replace(/\D/g, '');

  if (digitsOnly.length < 10) {
    return phoneNumber;
  }

  // Format as (XXX) XXX-XXXX
  const areaCode = digitsOnly.slice(0, 3);
  const middle = digitsOnly.slice(3, 6);
  const last = digitsOnly.slice(6, 10);

  return `(${areaCode}) ${middle}-${last}`;
}

export function formatCityStateZip(city?: string, state?: string, zip?: string) {
  const parts = [city, state, zip].filter(Boolean);
  if (parts.length === 0) return '';
  
  return parts.map((item, index) => {
    if (index === 0) return item; 
    if (index === 1) return `, ${item}`;
    return ` ${item}`;
  }).join('');
}

export function formatShopInfo(shopInfo: any) {
  if (!shopInfo) return { name: '', streetAddress: '', cityStateZip: '', phone: '' };
  
  const streetAddress = shopInfo.address || '';
  const cityStateZip = formatCityStateZip(shopInfo.city, shopInfo.state, shopInfo.zip);
    
  return {
    name: shopInfo.shopName || '',
    streetAddress: streetAddress,
    cityStateZip: cityStateZip,
    phone: formatPhoneNumber(shopInfo.phone)
  };
}
